// src/Games/ChineseTyping/ChineseTyping.js
import React, { useState, useEffect } from "react";
import "./ChineseTyping.css";
import zhuyinKeyboardImg from "./zhuyinKeyboard.png";

export const zhuyinData = [{
  "character": "你", "zhuyin": "su3"}, 
  {"character": "我", "zhuyin": "ji3"}, 
  {"character": "好", "zhuyin": "cl3"}, 
  {"character": "是", "zhuyin": "g4"}, 
  {"character": "不", "zhuyin": "1j4"}, 
  {"character": "人", "zhuyin": "bp6"}, 
  {"character": "有", "zhuyin": "u.3"}, 
  {"character": "在", "zhuyin": "y94"}, 
  {"character": "他", "zhuyin": "w8"}, 
  {"character": "這", "zhuyin": "5k4"}, 
  {"character": "那", "zhuyin": "s84"}, 
  {"character": "嗎", "zhuyin": "a87"}, 
  {"character": "的", "zhuyin": "2k7"}, 
  {"character": "一", "zhuyin": "u"}, 
  {"character": "二", "zhuyin": "-4"}, 
  {"character": "三", "zhuyin": "n0"}, 
  {"character": "上", "zhuyin": "g;4"}, 
  {"character": "中", "zhuyin": "5j/"}, 
  {"character": "年", "zhuyin": "su06"}, 
  {"character": "大", "zhuyin": "284"}, 
  {"character": "天", "zhuyin": "wu0"}, 
  {"character": "小", "zhuyin": "vul3"}, 
  {"character": "月", "zhuyin": "m,4"}, 
  {"character": "來", "zhuyin": "x96"}, 
  {"character": "下", "zhuyin": "vu84"}, 
  {"character": "國", "zhuyin": "eji6"}, 
  {"character": "地", "zhuyin": "2u4"}, 
  {"character": "出", "zhuyin": "tj"}, 
  {"character": "去", "zhuyin": "fm4"}, 
  {"character": "愛", "zhuyin": "94"}];

function ChineseTyping() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [typed, setTyped] = useState("");
  const [feedback, setFeedback] = useState("");
  const [score, setScore] = useState(0);

  const currentChar = zhuyinData[currentIndex];

  useEffect(() => {
    const handleKeyPress = (e) => {
      const key = e.key.toLowerCase();

      if (/^[a-z0-9,.;'/-]$/.test(key)) {
        const updated = typed + key;
        setTyped(updated);

        if (updated.length === currentChar.zhuyin.length) {
          if (updated === currentChar.zhuyin.toLowerCase()) {
            setFeedback("✅ Correct!");
            setScore((prev) => prev + 1);
            setTimeout(() => {
              setCurrentIndex((prev) => (prev + 1) % zhuyinData.length);
              setTyped("");
              setFeedback("");
            }, 800);
          } else {
            setFeedback("❌ Try Again");
            setTimeout(() => {
              setTyped("");
              setFeedback("");
            }, 800);
          }
        } else {
          setFeedback("");
        }
      }

      if (e.key === "Backspace") {
        setTyped((prev) => prev.slice(0, -1));
        setFeedback("");
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [typed, currentChar]);

  return (
    <div className="chinese-typing-container">
      <div className="typing-left-panel">
        <h2 className="game-title">🎮 Chinese Zhuyin Typing</h2>
        <div className="score-display">Score: {score}</div>
        <div className="chinese-character">{currentChar.character}</div>
        <p>Type the Zhuyin: <strong>{typed}</strong></p>
        <div className={`feedback ${feedback.includes("✅") ? "correct" : "incorrect"}`}>
          {feedback}
        </div>
      </div>

      <div className="typing-right-panel">
        <img
          src={zhuyinKeyboardImg}
          alt="Zhuyin Keyboard"
          className="zhuyin-keyboard-image"
        />
      </div>
    </div>
  );
}

export default ChineseTyping;
